class CaseStudy {
    constructor(context, settings, $) {
        // Values from Drupal
        this.context = context;
        this.settings = settings;
        this.$ = $;

        // Elements
        this.$items = this.$('[id^="js-slides--"]', this.context);

        this.$items.each((index, slider) => {
            $(slider).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                const i = (currentSlide ? currentSlide : 0) + 1;
                if (slick.slideCount > 1) {
                    $(slider).parent().find('.js-slide-number').text('(' + i + '/' + slick.slideCount + ')');
                }
            });

            $(slider).slick({
                autoplay: false,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: true,
                nextArrow: $('.js-right-arrow')[index],
                prevArrow: $('.js-left-arrow')[index],
                dots: false,
            });
        });
    }
}

export default CaseStudy;
